export const calculateRentCost = (boothType, rentByBoothType, squareMeter) => {
  if (boothType !== null && boothType.type in rentByBoothType) {
    const priceItem = rentByBoothType[props.basket.boothType.type]

    return (parseFloat(priceItem.cost_per_square_meter_net)
      * squareMeter )
	}

  return 0
}

export const calculateBoothCost = (pricePerSquareMeter, squareMeter) => {
	return parseFloat(pricePerSquareMeter) * squareMeter
}

export const calculateArticleCost = (articles, squareMeter, netValueOnly = false) => {
  let sum = 0.0

  for (let i = 0; i < articles.length; i++) {
		let article = articles[i]

    if (article.count > 0) {
			let articleCount = 0
			if (article.unit === 'sqm') {
				//calculate inclusive sqm with current booth size
				let boothInclusive = article.inclusive * squareMeter
				articleCount = article.count - article.inclusive > 0 ? ( article.count - boothInclusive ) : 0
      } else {
				articleCount = article.count - article.inclusive > 0 ? article.count - article.inclusive : 0
			}

      let netTotal = articleCount * parseFloat(article.exhibitionPrices.price_net);
			if(article.print_inclusive) {
        netTotal = 0;
      }
			article.totalNet = netTotal
			article.totalVat = (netTotal / 100) * ((netValueOnly) ? 0 : parseFloat(article.exhibitionPrices.price_vat_rate))
			article.total = article.totalNet + article.totalVat
			sum += article.totalNet // added totalNet because vat will be added later to total
		}
	}

  return sum
}

export const calculatePrintArticleCost = (
  printArticles, squareMeter, shoppingCart, netValueOnly = false, includedCharacters = 0
) => {
  let sum = 0.0
  for (const printItem of printArticles) {
    let articleCount = 0
    if (printItem.unit === 'sqm') {
      //calculate inclusive sqm with current booth size
      let boothInclusive = printItem.inclusive * squareMeter
      articleCount = ((printItem.count - printItem.inclusive) > 0)
        ? (printItem.count - boothInclusive)
        : 0
    } else {
      articleCount = ((printItem.count - printItem.inclusive) > 0)
        ? (printItem.count - printItem.inclusive)
        : 0
    }

    if (
      printItem.booth_refinement_id !== null
      && shoppingCart.isBoothConfigurationLettering(printItem.booth_refinement_id)
      && includedCharacters > 0
    ) {
      if (printItem.count <= includedCharacters) {
        printItem.inclusive = printItem.count
        articleCount = 0
      } else {
        printItem.inclusive = includedCharacters
        articleCount = printItem.count - includedCharacters
      }
      printItem.count_after_inclusive = articleCount
    } else {
      printItem.count_after_inclusive = printItem.count
      printItem.inclusive = 0
    }

    let netTotal = 0
    if(printItem.print_inclusive) {
      netTotal = 0
    } else {
      netTotal = articleCount * parseFloat(printItem.exhibitionPrices.price_net)
    }
    
    printItem.totalNet = netTotal
    printItem.totalVat = (netTotal / 100) * ((netValueOnly) ? 0 : parseFloat(printItem.exhibitionPrices.price_vat_rate))
    printItem.total = printItem.totalNet + printItem.totalVat
    sum += printItem.totalNet // added totalNet because vat will be added later to total
  }

  return sum
}

export const calculateAdditionalCost = (additionalCosts) => {
  if (
		additionalCosts == null
		|| additionalCosts.length == 0
	) {
		return 0
	}

	let price = 0
	for (let i = additionalCosts.length - 1; i >= 0; i--) {
		price += additionalCosts[i].amount
	}

	return price
}

export const calculatePriceLevelCost = (activePriceLevel, boothCost, articlesCost) => {
  let costs = (parseFloat(boothCost) + parseFloat(articlesCost))
    * (parseFloat(activePriceLevel.percentage) / 100)

  if (activePriceLevel.type === 0) {
    costs *= -1
  }

  return costs
}

export const calculateTotal = (computedPrices) => {
	return parseFloat(computedPrices.exhibitionAdditionalCost)
    + parseFloat(computedPrices.exhibitionRentCost)
    + parseFloat(computedPrices.boothCost)
    + parseFloat(computedPrices.articlesCost)
    + parseFloat(computedPrices.priceLevelCost)
}

export const calculateTotalGross = (total, vatRate) => {
	return parseFloat(total) * (1 + vatRate * 0.01)
}